import React from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';

import ApplicationAllocationContainer from './ApplicationAllocationContainer';
import { SpendTypeEnum } from 'components/Classification';

import { CONFIG, ROOT_ROUTE } from './routes';
import { ApiContext } from 'context/ApiContext';

interface IProps {
  permissions: string[];
}

export const ApplicationAllocationView: React.FC<IProps> = ({
  permissions,
}) => {
  return (
    <Switch>
      <Route
        path={`${ROOT_ROUTE}/:spendType(${CONFIG.filter((item) => {
          return (
            !item.permission ||
            (permissions && permissions.includes(item.permission))
          );
        })
          .map((tab) => tab.name)
          .join('|')})`}
        exact
        render={({ match }) => (
          <ApplicationAllocationContainer
            spendType={match.params.spendType as SpendTypeEnum}
          />
        )}
      />
      <Redirect to={CONFIG[0].path} />
    </Switch>
  );
};

export default (props: any) => (
  <ApiContext.Consumer>
    {({ permissions }) => {
      return <ApplicationAllocationView {...props} permissions={permissions} />;
    }}
  </ApiContext.Consumer>
);
